
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(ocelot)/_preview/[component]",
      function () {
        return require("private-next-pages/(ocelot)/_preview/[component].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(ocelot)/_preview/[component]"])
      });
    }
  